import { Modal } from 'ui';
import { ProgramInviteForm } from './program-invite-form';

type P = {
  isOpened: boolean;
  onClose: () => void;
  programId: string;
};

const ProgramInviteModal = ({ isOpened, onClose, programId }: P) => (
  <Modal isOpened={isOpened} onCancel={onClose} title="Enroll Members" width="medium">
    <Modal.HugContent>
      <ProgramInviteForm onClose={onClose} programId={programId} />
    </Modal.HugContent>
  </Modal>
);

export default ProgramInviteModal;
